import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated import
import App from './App';
import './styles/index.css';
import UserProvider from './contexts/UserProvider';
import AuthProvider from './contexts/AuthProvider';
import { DealershipProvider } from './contexts/DealershipContext';
import { EmployeeProvider } from './contexts/EmployeeContext';
import CartProvider from './contexts/CartContext';

// Select the root DOM node
const container = document.getElementById('root');

// Create a root
const root = ReactDOM.createRoot(container);

// Initial render
root.render(
  <React.StrictMode>
    <AuthProvider>
      <UserProvider>
        <DealershipProvider>
          <EmployeeProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </EmployeeProvider>
        </DealershipProvider>
      </UserProvider>
    </AuthProvider>
  </React.StrictMode>
);
